export default "__VITE_ASSET__COWh5m_A__"